import React,{useState, useEffect} from 'react'
import Header from '../layout/Header'
import Sidebar from '../layout/Sidebar'
import Breadcrumb from '../pages/Breadcrumb'
import AxiosURL from '../../ApiService/AxiosURL'
import emitter from '../pages/emitter'
import './milldashboard.css';
import {ComposedChart, 
        XAxis, 
        YAxis, 
        Tooltip, 
        Legend, 
        CartesianGrid, 
        Area, 
        Bar, 
        Line, 
        ResponsiveContainer} from 'recharts';

export default function Milldashboard() {
    let millDataApi = "/farmers/stock_castor";
    let stockInHandApi = "/farmers/stock_in_castor";
    const [millData, setMillData] = useState([]);
    const [isLoading, setIsLoading] = useState([]);
    const [stockIHand, setStockInHand] = useState([]);

    useEffect(()=>{
        fetchStockMillData(millDataApi);
        fetchStockInHand(stockInHandApi);
        const lister = emitter.addListener("sendFilterData",districtDataFilter)
        return ()=>lister.remove();
    },[]);

    const fetchStockMillData =async(url)=>{
       try{
        const response = await AxiosURL.get(url);
        setMillData(response.data.data);
        // console.log(response.data);
       }catch(error){
        console.log(error);
       }
    }
    const fetchStockInHand = async(url)=>{
      try{
        const response = await AxiosURL.get(url);
        setStockInHand(response.data.data);
        console.log(response.data.data);
      }catch(error){
        console.log(error);
      }
    }


    // Ganesh was written the code
   const districtDataFilter = async (distData)=>{
    var villData = distData['village'];
    var farmerName = distData['name'];
    console.log(farmerName);
    if(distData['district'])
    {
      if(distData.district == 'select')
      {
        fetchStockMillData(millDataApi);
        fetchStockInHand(stockInHandApi);

      }else{
        setIsLoading(true);
        const response = await AxiosURL.get(millDataApi,{ params:distData})
        setMillData(response.data.data);
        getStockInHand(distData);
      }
    }
    else if(distData['village'])
    {
      if(distData.village ==0)
      {
        fetchStockMillData(millDataApi);      
      }else{
        setIsLoading(true);
        const response = await AxiosURL.get(millDataApi,{ params:distData,"village":villData})
        setMillData(response.data.data)
        setIsLoading(false);
      }
    }
    else{
        if(distData.name ==0)
        {
            fetchStockMillData(millDataApi); 
        }
        else
        {
            setIsLoading(true);
            const response = await AxiosURL.get(millDataApi,{params:distData,"village":villData, "name":farmerName});
            setMillData(response.data.data);
            setIsLoading(false);
        }
    }
  }
  const getStockInHand = async(distData)=>{
    const response = await AxiosURL.get(stockInHandApi,{params:distData});
    setStockInHand(response.data.data);
  }

  return (
    <>
      <div className='wrapper card-body'>
    <Sidebar />
    <div className='main '>
      <Header/>
      <main className='content'>
      <div className='container-fluid p-0'>
<Breadcrumb /><br />
<section className='row '>
    <div className='row'>
        <div className='col col-md-12'>
            <div className='card'>
               <div className='card-body milldatagraph'>
                <span>
                 <p className='contentformillgraph'>
                    This graph shows the amount of produced, sold and stock in hand castor over a period of six years (2016-2021).
                    The data is presented using a grouped  chart, like BarChart, AreaChart & LineChart.
                    In the each bar represents a year, and  castor sold data,
                    In the areachart represets the year wise castor produced data, same as that in the linechart represnt the stock in hand castor. </p></span>
                    
                <ComposedChart width={1200} height={550} data={millData}>
                <XAxis dataKey="year" />
                <YAxis />
                <Tooltip />
                <Legend />
                <CartesianGrid stroke="#f5f5f5" />
                <Area type="monotone" dataKey="castor_produced" fill="#FF9900" stroke="#FF9900" unit=" kg"/>
                <Bar dataKey="castor_sold" barSize={80} fill="#229af5" unit=" kg"/>
                <Line type="monotone" dataKey="stock" stroke="#000000" unit=" kg"/>
                </ComposedChart>
                                </div>
            </div>
        </div>
    </div>
    <div className='row'>
      <div className='col col-md-12'>
        
      <div className='card mt-4'>
                        <div className='card-body milldatagraph'>
                        <p className='contentformillgraph mt-4'>
                        Here are  representing the castor data  produced, sold, stock and stock in hand castor in tabular formate with year wise.
                        </p>
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th>Year</th>
                                <th>Castor Produce</th>
                                <th>Castor Sold</th>
                                <th>Stock </th>
                                <th>Stock in hand</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{stockIHand.year_16} </td>
                                <td>{stockIHand.castor_produced_16} kg.</td>
                                <td>{stockIHand.castor_sold_16} kg.</td>
                                <td>{stockIHand.stock_16} kg.</td>
                                <td>{stockIHand.stock_in_hand_16} kg.</td>
                              </tr>
                              <tr>
                                <td>{stockIHand.year_17} </td>
                                <td>{stockIHand.castor_produced_17} kg.</td>
                                <td>{stockIHand.castor_sold_17} kg.</td>
                                <td>{stockIHand.stock_17} kg.</td>
                                <td>{stockIHand.stock_in_hand_17} kg.</td>
                              </tr>
                              <tr>
                                <td>{stockIHand.year_18} </td>
                                <td>{stockIHand.castor_produced_18} kg.</td>
                                <td>{stockIHand.castor_sold_18} kg.</td>
                                <td>{stockIHand.stock_18} kg.</td>
                                <td>{stockIHand.stock_in_hand_18} kg.</td>
                              </tr>
                              <tr>
                                <td>{stockIHand.year_19} </td>
                                <td>{stockIHand.castor_produced_19} kg.</td>
                                <td>{stockIHand.castor_sold_19} kg.</td>
                                <td>{stockIHand.stock_19} kg.</td>
                                <td>{stockIHand.stock_in_hand_19} kg.</td>
                              </tr>
                              <tr>
                                <td>{stockIHand.year_20} </td>
                                <td>{stockIHand.castor_produced_20} kg.</td>
                                <td>{stockIHand.castor_sold_20} kg.</td>
                                <td>{stockIHand.stock_20} kg.</td>
                                <td>{stockIHand.stock_in_hand_20} kg.</td>
                              </tr>
                              <tr>
                                <td>{stockIHand.year_21} </td>
                                <td>{stockIHand.castor_produced_21} kg.</td>
                                <td>{stockIHand.castor_sold_21} kg.</td>
                                <td>{stockIHand.stock_21} kg.</td>
                                <td>{stockIHand.stock_in_hand_21} kg.</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        </div>
      </div>
    </div>
</section>
</div>
</main>
</div>
</div>
    </>
  )
}
